import React from 'react'
import PropTypes from 'prop-types'
import { Form, Input } from 'antd'
import css from '../../common/Form.css'

const OpenchairUrl = ({ onChange, value }) => (
  <div className={css.formGroup}>
    <h3>New Patient Online Scheduling</h3>
    <Form.Item label="Practice URL. Required for OS. Can't have a path (stuff after .com/)" className={css.itemLabel} key="website">
      <Input
        placeholder="www.example.com"
        value={value}
        onChange={onChange}
        className={css.input}
        name="website"
      />
    </Form.Item>
  </div>
)

OpenchairUrl.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
}

OpenchairUrl.defaultProps = {
  value: null,
}

export default OpenchairUrl



// WEBPACK FOOTER //
// ./src/AddPractice/Products/OpenchairUrl.js